/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Eyebrow_RoutineInputs */

const en_us2_profile_editors_eyebrow_routine = /** @type {(inputs: Profile_Editors_Eyebrow_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training routine`)
};

const pt_br2_profile_editors_eyebrow_routine = /** @type {(inputs: Profile_Editors_Eyebrow_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotina de treino`)
};

const es_419_profile_editors_eyebrow_routine = /** @type {(inputs: Profile_Editors_Eyebrow_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rutina de entrenamiento`)
};

const pt_pt2_profile_editors_eyebrow_routine = /** @type {(inputs: Profile_Editors_Eyebrow_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotina de treino`)
};

const fr_fr2_profile_editors_eyebrow_routine = /** @type {(inputs: Profile_Editors_Eyebrow_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rythme d'entraînement`)
};

const de_de2_profile_editors_eyebrow_routine = /** @type {(inputs: Profile_Editors_Eyebrow_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingsroutine`)
};

const it_it2_profile_editors_eyebrow_routine = /** @type {(inputs: Profile_Editors_Eyebrow_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routine di allenamento`)
};

/**
* | output |
* | --- |
* | "Training routine" |
*
* @param {Profile_Editors_Eyebrow_RoutineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_eyebrow_routine = /** @type {((inputs?: Profile_Editors_Eyebrow_RoutineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Eyebrow_RoutineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_eyebrow_routine(inputs)
	if (locale === "es-419") return es_419_profile_editors_eyebrow_routine(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_eyebrow_routine(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_eyebrow_routine(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_eyebrow_routine(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_eyebrow_routine(inputs)
	return en_us2_profile_editors_eyebrow_routine(inputs)
});
export { profile_editors_eyebrow_routine as "profile-editors.eyebrow_routine" }